<span style="white-space: nowrap;"><span [ngStyle]="{'font-size':currencySymbolFontSize}">₹</span> {{transform(amount)}}</span>